webpackJsonp([1],{

/***/ 127:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-music.e2c5258.png";

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(157),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6da3d88a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(158),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7483cee2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(127)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(154),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-093b7478",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(156),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 154:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "smooth-appear",
      rawName: "v-smooth-appear",
      value: ({
        elements: '.smooth-appear-project',
        wait: 200,
        duration: 500,
        delay: 10,
        translate: 30
      }),
      expression: "{elements: '.smooth-appear-project', wait: 200, duration: 500, delay: 10, translate: 30}"
    }],
    staticClass: "skills-list"
  }, [_vm._l((_vm.items), function(item, index) {
    return [(item === '<br>') ? _c('br', {
      key: index
    }) : _c('div', {
      key: index,
      staticClass: "item smooth-appear-project"
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.component, {
    tag: "component",
    staticClass: "ui-button"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "smooth-appear",
      rawName: "v-smooth-appear",
      value: ({
        elements: '.smooth-appear'
      }),
      expression: "{elements: '.smooth-appear'}"
    }],
    staticClass: "root"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h1', {
    staticClass: "title smooth-appear"
  }, [_vm._v("\n      Vladimir Verstoff\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub smooth-appear"
  }, [_vm._v("\n      Web Developer\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "location smooth-appear"
  }, [_c('icon', {
    attrs: {
      "name": "location"
    }
  }), _vm._v("\n      RUSSIA, SIBERIA, 54\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "experience smooth-appear"
  }, [_vm._v("\n      4 year's experience\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "skills"
  }, [_c('skills-list', {
    staticClass: "skills__category",
    attrs: {
      "items": _vm.skills[0]
    }
  }), _vm._v(" "), _c('skills-list', {
    staticClass: "skills__category",
    attrs: {
      "items": _vm.skills[1]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "projects"
  }, [_c('project-list', {
    attrs: {
      "items": _vm.projects
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "contact smooth-appear"
  }, [_c('ui-button', {
    staticClass: "contact__button",
    attrs: {
      "href": "mailto:contact@verstoff.ru",
      "target": "_blank"
    }
  }, [_vm._v("\n        CONTACT\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links smooth-appear"
  }, _vm._l((_vm.socials), function(url, network) {
    return _c('a', {
      key: network,
      staticClass: "social-link",
      attrs: {
        "href": url,
        "target": "_blank"
      }
    }, [_c('icon', {
      staticClass: "social-link__icon",
      attrs: {
        "name": network,
        "height": "30",
        "width": "auto"
      }
    })], 1)
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "smooth-appear",
      rawName: "v-smooth-appear",
      value: ({
        elements: '.smooth-appear-project',
        wait: 1000,
        duration: 600,
        delay: 100,
        translate: 30
      }),
      expression: "{elements: '.smooth-appear-project', wait: 1000, duration: 600, delay: 100, translate: 30}"
    }],
    staticClass: "project-list"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item-wrapper smooth-appear-project"
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "thumbnail",
      attrs: {
        "src": item.thumbnail
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('h3', {
      staticClass: "title"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('h4', {
      staticClass: "subtitle"
    }, [_vm._v("\n          " + _vm._s(item.subtitle) + "\n        ")])])])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(26);






var SmoothAppear = {
  // hook
  inserted: function inserted(el, binding) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _Vue$popmotion, styler, timeline, easing, elements, items, labels, tweenUp, setStylers;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _Vue$popmotion = __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].popmotion, styler = _Vue$popmotion.styler, timeline = _Vue$popmotion.timeline, easing = _Vue$popmotion.easing;
              elements = SmoothAppear.getElements(el, binding);
              items = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(elements).map(styler);
              labels = items.map(function (s, i) {
                return 'smooth-appear-' + i;
              });

              tweenUp = function tweenUp(track, duration, yFrom) {
                return {
                  track: track,
                  duration: duration,
                  from: { y: yFrom, opacity: 0 },
                  to: { y: 0, opacity: 1 },
                  ease: { y: easing.backOut, opacity: easing.linear }
                };
              };

              setStylers = function setStylers(v) {
                labels.forEach(function (label, i) {
                  if (v[label] !== undefined) items[i].set(v[label]);
                });
              };

              timeline([binding.value.wait || 0, [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(items.map(function (s, i) {
                return tweenUp(labels[i], binding.value.duration || 700, binding.value.translate || 50);
              })), [binding.value.delay || 30])]).start({
                update: setStylers,
                complete: function complete() {
                  items.forEach(function (item) {
                    item.set({ y: undefined, opacity: undefined });
                  });
                }
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getElements: function getElements(el, binding) {
    var v = binding.value.elements;
    if (!v) {
      return el.childNodes();
    }
    if (typeof v === 'string') {
      return el.querySelectorAll(v);
    }
    return v;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SmoothAppear);

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(155),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__(10);
icon.register({
  'github': {
    width: 1024,
    height: 1024,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512 0C229.25 0 0 229.25 0 512c0 226.25 146.688 418.125 350.156 485.812 25.594 4.688 34.938-11.125 34.938-24.625 0-12.188-.469-52.562-.719-95.312C242 908.812 211.906 817.5 211.906 817.5c-23.312-59.125-56.844-74.875-56.844-74.875-46.531-31.75 3.53-31.125 3.53-31.125 51.406 3.562 78.47 52.75 78.47 52.75 45.688 78.25 119.875 55.625 149 42.5 4.654-33 17.904-55.625 32.5-68.375-113.656-12.937-233.218-56.875-233.218-253.063 0-55.938 19.969-101.562 52.656-137.406-5.219-13-22.844-65.094 5.062-135.562 0 0 42.938-13.75 140.812 52.5 40.812-11.406 84.594-17.031 128.125-17.219 43.5.188 87.312 5.875 128.188 17.281 97.688-66.312 140.688-52.5 140.688-52.5 28 70.531 10.375 122.562 5.125 135.5 32.812 35.844 52.625 81.469 52.625 137.406 0 196.688-119.75 240-233.812 252.688 18.438 15.875 34.75 47 34.75 94.75 0 68.438-.688 123.625-.688 140.5 0 13.625 9.312 29.562 35.25 24.562C877.438 930 1024 738.125 1024 512 1024 229.25 794.75 0 512 0z"/>'
  }
});

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
__webpack_require__(81);
__webpack_require__(83);
__webpack_require__(84);
__webpack_require__(85);

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__(10);
icon.register({
  'linkedin': {
    width: 16,
    height: 16,
    viewBox: '0 0 67 67',
    data: '<path pid="0" class="st0" d="M52.3 49.3v-13c0-7-3.7-10.2-8.7-10.2-4 0-5.8 2.2-6.8 3.8v-3.2h-7.6c.1 2.1 0 22.8 0 22.8h7.6V36.6c0-.7 0-1.4.2-1.8.5-1.4 1.8-2.8 3.9-2.8 2.7 0 3.8 2.1 3.8 5.1v12.2h7.6zm-31-25.9c2.6 0 4.3-1.7 4.3-3.9s-1.6-3.9-4.2-3.9-4.4 1.7-4.4 3.9 1.7 3.9 4.3 3.9zM33.6 67C15.1 67 .1 52 .1 33.6.1 15.1 15.1.2 33.5.2S67 15.1 67 33.6C67 52 52 67 33.6 67zM25 49.3V26.6h-7.6v22.8H25z"/>'
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__(10);
icon.register({
  'location': {
    width: 141.732,
    height: 141.732,
    viewBox: '0 0 141.732 141.732',
    data: '<path pid="0" d="M95.35 50.645c0 13.98-11.389 25.322-25.438 25.322-14.051 0-25.438-11.342-25.438-25.322 0-13.984 11.389-25.322 25.438-25.322C83.964 25.322 95.35 36.66 95.35 50.645m26.393 0C121.743 22.674 98.966 0 70.866 0 42.768 0 19.989 22.674 19.989 50.645c0 12.298 4.408 23.574 11.733 32.345l39.188 56.283 39.761-57.104a50.048 50.048 0 0 0 3.916-5.625l.402-.574h-.066a50.245 50.245 0 0 0 6.82-25.325"/>'
  }
});

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__(10);
icon.register({
  'producthunt': {
    width: 16,
    height: 16,
    viewBox: '0 0 56.7 56.7',
    data: '<path pid="0" d="M28.3 0C12.7 0 0 12.7 0 28.3 0 44 12.7 56.7 28.3 56.7 44 56.7 56.7 44 56.7 28.3 56.7 12.7 44 0 28.3 0zm3.8 34h-8v8.5h-5.7V14.2h13.7c5.5 0 9.9 4.4 9.9 9.9S37.6 34 32.1 34z"/><path pid="1" d="M32.1 19.8h-8v8.5h8c2.3 0 4.3-1.9 4.3-4.3 0-2.3-1.9-4.2-4.3-4.2z"/>'
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_svgicon__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_svgicon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_svgicon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_popmotion__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_popmotion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_popmotion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_popmotion__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_popmotion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_popmotion__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_svgicon__, {
  tagName: 'icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_popmotion___default.a, __WEBPACK_IMPORTED_MODULE_4_popmotion__);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SkillsList__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SkillsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SkillsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectList__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProjectList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UiButton__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UiButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UiButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_SmoothAppear__ = __webpack_require__(27);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      skills: [['HTML5', 'Web Extensions', 'CSS3', 'BEM', 'LESS/SASS', 'JS (ES6+)', 'Vue.js', 'Vuex', 'Socket.io', 'SW', 'Webpack'], ['Node.js', 'Express.js', 'Strapi', 'PHP7', 'Yii Framework 1/2', 'MySQL', 'Redis', 'Sphinx', 'Ceph', 'RabbitMQ', 'Docker', 'Vagrant']],
      projects: [{
        title: 'Atavi.com',
        subtitle: 'Bookmark management service',
        url: 'https://atavi.com/about?from=verstoff',
        thumbnail: __webpack_require__(149)
      }, {
        title: 'Find on Apple Music',
        subtitle: 'Google Chrome extension',
        url: 'https://chrome.google.com/webstore/detail/find-on-apple-music/bicaojpdepgklhhaebcokkcakakbglpe',
        thumbnail: __webpack_require__(148)
      }],
      socials: {
        linkedin: 'https://www.linkedin.com/in/vladimir-verstov-244335111/',
        github: 'https://github.com/verstoff/',
        producthunt: 'https://www.producthunt.com/@vladimir_verstov/made'
      }
    };
  },

  components: {
    SkillsList: __WEBPACK_IMPORTED_MODULE_1__SkillsList___default.a, ProjectList: __WEBPACK_IMPORTED_MODULE_2__ProjectList___default.a, UiButton: __WEBPACK_IMPORTED_MODULE_3__UiButton___default.a
  },
  directives: {
    SmoothAppear: __WEBPACK_IMPORTED_MODULE_4__directives_SmoothAppear__["a" /* default */]
  }
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_SmoothAppear__ = __webpack_require__(27);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['items'],
  directives: {
    SmoothAppear: __WEBPACK_IMPORTED_MODULE_0__directives_SmoothAppear__["a" /* default */]
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_SmoothAppear__ = __webpack_require__(27);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['items'],
  directives: {
    SmoothAppear: __WEBPACK_IMPORTED_MODULE_0__directives_SmoothAppear__["a" /* default */]
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    component: {
      type: String,
      default: 'a'
    }
  }
});

/***/ })

},[86]);


// WEBPACK FOOTER //
// static/js/app.496f4668e1151f5211bc.js